import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { Trans } from "@coworker/locales";
import styles from "./item-last-refill.module.css";

interface ItemLastRefillProps {
  lastRefilledDate: string;
  lastRefilledQuantity: number;
}

export const ItemLastRefill = ({
  lastRefilledDate,
  lastRefilledQuantity,
}: ItemLastRefillProps) => {
  return (
    <FixaText
      className={styles["last-refill-container"] || ""}
      textStyle={"Body.S"}
    >
      <Trans count={`${lastRefilledDate} • ${lastRefilledQuantity}`}>
        lastRefilledAt
      </Trans>
    </FixaText>
  );
};
